import { TranslationVehiclesModuleMessages, VehiclesModuleMessages } from "../interfaces";

export const messages: TranslationVehiclesModuleMessages = {
  // region Backend messages

  // region Vehicle-events messages
  [VehiclesModuleMessages.updateVehicleEventSuccess]: "Evento modificado con éxito",
  [VehiclesModuleMessages.eventNotFound]: "Evento no registrado en nuestro sistema",
  [VehiclesModuleMessages.updateVehicleEventError]: "Falla al actualizar evento",
  [VehiclesModuleMessages.readVehicleEventSuccess]: "Evento(s) devuelto(s) con éxito",
  [VehiclesModuleMessages.noVehicleEventFound]: "Ningún evento registrado para el viaje en cuestión",
  [VehiclesModuleMessages.readVehicleEventError]: "Falla al buscar evento(s)",
  // endregion
  // region Vehicles-states messages
  [VehiclesModuleMessages.createVehicleStateSuccess]: "Estado de vehículo registrado con éxito",
  [VehiclesModuleMessages.createVehicleStateError]: "Falla al registrar estado de vehículo",
  [VehiclesModuleMessages.readVehicleStateSuccess]: "Estado(s) de vehículo devuelto(s) con éxito",
  [VehiclesModuleMessages.noVehicleStateFound]: "Ningún estado de vehículo registrado",
  [VehiclesModuleMessages.readVehicleStateError]: "Falla al buscar estado(s) de vehículo(s)",
  [VehiclesModuleMessages.noVehicleStateInTravelFound]: "Ningún estado de vehículo registrado para el viaje en cuestión",
  [VehiclesModuleMessages.getVehiclesAndTravelsError]: "Falla al buscar informaciones de los vehículos y viajes",
  [VehiclesModuleMessages.getVehiclesHardwaresError]: "Falla al buscar informaciones de los hardwares de los vehículos",
  [VehiclesModuleMessages.getVehiclesAlertsError]: "Falla al buscar informaciones de las alertas de los vehículos",
  [VehiclesModuleMessages.getMixerTravelsSpecificInfoError]: "Falla al buscar informaciones específicas de los viajes de hormigonera",
  [VehiclesModuleMessages.getPumpTravelsSpecificInfoError]: "Falla al buscar informaciones específicas de los viajes de bomba",
  [VehiclesModuleMessages.getAggregateTruckTravelsSpecificInfoError]: "Falla al buscar informaciones específicas de los viajes de camión de agregado",
  [VehiclesModuleMessages.noVehicleStateInVehicleFound]: "Ningún estado de vehículo registrado para el vehículo ",
  // endregion
  // region Vehicle-states-types messages
  [VehiclesModuleMessages.readVehicleStateTypeSuccess]: "Tipo(s) de estados de vehículo devuelto(s) con éxito",
  [VehiclesModuleMessages.noVehicleStateTypeFound]: "Ningún tipo de estado de vehículo registrado",
  [VehiclesModuleMessages.readVehicleStateTypeError]: "Falla al buscar tipo(s) de estado(s) de vehículo(s)",
  // endregion
  // region Vehicle-types messages
  [VehiclesModuleMessages.readVehicleTypeSuccess]: "Tipo(s) de vehículo(s) devuelto(s) con éxito",
  [VehiclesModuleMessages.noVehicleTypeFound]: "Ningún tipo de vehículo registrado",
  [VehiclesModuleMessages.readVehicleTypeError]: "Falla al buscar tipo(s) de vehículo(s)",
  // endregion
  // region Vehicles messages
  [VehiclesModuleMessages.createVehicleSuccess]: "Vehículo registrado con éxito",
  [VehiclesModuleMessages.createVehicleError]: "Falla al registrar vehículo",
  [VehiclesModuleMessages.readVehicleSuccess]: "Vehículo(s) devuelto(s) con éxito",
  [VehiclesModuleMessages.noVehicleFound]: "Ningún vehículo encontrado",
  [VehiclesModuleMessages.readVehicleError]: "Falla al buscar vehículo(s)",
  [VehiclesModuleMessages.updateVehicleSuccess]: "Vehículo modificado con éxito",
  [VehiclesModuleMessages.vehicleNotFound]: "Vehículo no registrado en nuestro sistema",
  [VehiclesModuleMessages.updateVehicleError]: "Falla al actualizar vehículo",
  [VehiclesModuleMessages.deleteVehicleSuccess]: "Vehículo excluido con éxito",
  [VehiclesModuleMessages.onlyInactivateVehicleMessage]: "Vehículo con más de un estado no puede ser excluido, solo inactivado",
  [VehiclesModuleMessages.deleteVehicleError]: "Falla al excluir vehículo",
  [VehiclesModuleMessages.code]: "Código",
  [VehiclesModuleMessages.licensePlate]: "Placa",
  [VehiclesModuleMessages.invalidUserOrPassword]: "Usuario o contraseña inválidos",
  [VehiclesModuleMessages.userNotAuthorizedToBlockVehicle]: "Usuario no autorizado a bloquear vehículo",
  [VehiclesModuleMessages.vehicleWithoutHardware]: "Vehículo no posee hardware",
  [VehiclesModuleMessages.vehicleWithoutBlockCapableHardware]: "Vehículo no posee hardware con bloqueo",
  [VehiclesModuleMessages.blockRequestSent]: "Bloqueo solicitado con éxito",
  [VehiclesModuleMessages.unblockRequestSent]: "Desbloqueo solicitado con éxito",
  [VehiclesModuleMessages.blockRequestError]: "Falla al solicitar bloqueo",
  [VehiclesModuleMessages.getVehicleInfoSuccess]: "Informaciones del vehículo devueltas con éxito",
  [VehiclesModuleMessages.getVehicleInfoError]: "Falla al buscar informaciones del vehículo",
  [VehiclesModuleMessages.updateVehicleConfigSuccess]: "Configuración del vehículo actualizada con éxito",
  [VehiclesModuleMessages.updateVehicleConfigError]: "Falla al actualizar configuración del vehículo",
  [VehiclesModuleMessages.batchUpdateMaxSpeedSuccess]: "Velocidad máxima actualizada con éxito",
  [VehiclesModuleMessages.batchUpdateMaxSpeedError]: "Falla al actualizar velocidad máxima de los vehículos",
  [VehiclesModuleMessages.general]: "General",
  [VehiclesModuleMessages.concreteMixers]: "Hormigoneras",
  [VehiclesModuleMessages.pumpTrucks]: "Bombas",
  [VehiclesModuleMessages.supportVehicles]: "Apoyo",
  [VehiclesModuleMessages.total]: "Total",
  [VehiclesModuleMessages.average]: "Promedio",

  // region Vehicle types
  [VehiclesModuleMessages.concreteMixer]: "Hormigonera",
  [VehiclesModuleMessages.concreteMixers]: "Hormigoneras",
  [VehiclesModuleMessages.pumpTruck]: "Camión de bomba",
  [VehiclesModuleMessages.pumpTrucks]: "Camiones de bomba",
  [VehiclesModuleMessages.supportVehicles]: "Vehículos de apoyo",
  [VehiclesModuleMessages.supportVehicle]: "Vehículo de apoyo",
  [VehiclesModuleMessages.loaders]: "Cargadores",
  [VehiclesModuleMessages.loader]: "Cargador",
  [VehiclesModuleMessages.aggregateTrucks]: "Camiones de agregado",
  [VehiclesModuleMessages.aggregateTruck]: "Camión de agregado",
  [VehiclesModuleMessages.siloTrucks]: "Camiones silo",
  [VehiclesModuleMessages.siloTruck]: "Camión silo",
  // endregion

  // endregion
  // region Integration messages
  [VehiclesModuleMessages.locationNotRegistered]: "Ubicación(es) no registrada(s)",
  [VehiclesModuleMessages.driverNotRegistered]: "Conductor(es) no registrado(s)",
  [VehiclesModuleMessages.externalIDAlreadyRegistered]: "ID(s) externo(s) ya registrado(s)",
  [VehiclesModuleMessages.licensePlateAlreadyRegistered]: "Placa(s) ya registrada(s)",
  [VehiclesModuleMessages.codeAlreadyRegistered]: "Código(s) ya registrado(s)",
  [VehiclesModuleMessages.invalidDateFormat]: "Formato de fecha inválido",
  [VehiclesModuleMessages.noDataForThisVehicleOrDay]: "No hay datos para este vehículo y/o día",
  [VehiclesModuleMessages.readVehicleDailySummarySuccess]: "Resumen diario de vehículo(s) devuelto(s) con éxito",
  [VehiclesModuleMessages.vehicleWithoutTracker]: "Vvehículo no tiene un rastreador vinculado",
  [VehiclesModuleMessages.invalidTrackerReadingsRange]: "Período inválido. Informe start_date y finish_date, con un máximo de 1 día entre ellas",
  [VehiclesModuleMessages.invalidVehicleHistoryDateRange]: "Intervalo de fechas inválido. Máximo permitido: 60 días",
  [VehiclesModuleMessages.readTrackerReadingsSuccess]: "Lecturas del rastreador obtenidas con éxito",
  // endregion

  // endregion
  // region Frontend messages

  // region General
  [VehiclesModuleMessages.description]: "Descripción",
  [VehiclesModuleMessages.status]: "Status",
  [VehiclesModuleMessages.odometer]: "Odómetro",
  [VehiclesModuleMessages.odometerInKm]: "Odómetro (km)",
  [VehiclesModuleMessages.hourMeter]: "Horímetro",
  [VehiclesModuleMessages.hourMeterInHours]: "Horímetro (h)",
  [VehiclesModuleMessages.maintenance]: "En mantenimiento",
  [VehiclesModuleMessages.originalAllocation]: "Asignación original",
  [VehiclesModuleMessages.currentAllocation]: "Asignación actual",
  [VehiclesModuleMessages.currentEvent]: "Evento actual",
  [VehiclesModuleMessages.searchingVehicles]: "Buscando vehículos...",
  [VehiclesModuleMessages.vehicleDeleteConfirmation]: "¿Está seguro que desea excluir el vehículo?",
  [VehiclesModuleMessages.vehicleRegistration]: "Registro de vehículo",
  [VehiclesModuleMessages.activeVehicle]: "Vehículo activo",
  [VehiclesModuleMessages.active]: "activo",
  [VehiclesModuleMessages.inactive]: "Inactivo",
  [VehiclesModuleMessages.vehicleUnderMaintenance]: "Vehículo en mantenimiento",
  [VehiclesModuleMessages.vehicleType]: "Tipo de vehículo",
  [VehiclesModuleMessages.maxSpeedAllowed]: "Velocidad máxima permitida",
  [VehiclesModuleMessages.maxSpeedAllowedTooltip]: "La alerta de velocidad se generará considerando una variación de hasta 5% por encima del valor configurado.",
  [VehiclesModuleMessages.allocationPlant]: "Central de asignación",
  [VehiclesModuleMessages.defaultDriver]: "Conductor padrón",
  [VehiclesModuleMessages.title]: "Vehículos",
  [VehiclesModuleMessages.deleteDialogTitle]: "Confirmación de exclusión",
  [VehiclesModuleMessages.vehicles]: "Vehículos",
  [VehiclesModuleMessages.blocks]: "Bloqueos",
  [VehiclesModuleMessages.group]: "Grupo",
  [VehiclesModuleMessages.regional]: "Regional",
  [VehiclesModuleMessages.plant]: "Central",
  [VehiclesModuleMessages.lastCommunicationDate]: "Fecha de última comunicación",
  [VehiclesModuleMessages.lastCommunication]: "Última comunicación",
  [VehiclesModuleMessages.ignition]: "Encendido",
  [VehiclesModuleMessages.lastIgnitionDate]: "Último encendido",
  [VehiclesModuleMessages.lastPlantExitDate]: "Última salida de la central",
  [VehiclesModuleMessages.currentLatitude]: "Latitud actual",
  [VehiclesModuleMessages.currentLongitude]: "Longitud actual",
  [VehiclesModuleMessages.currentAddress]: "Dirección actual",
  [VehiclesModuleMessages.activeHardware]: "GPS activo",
  [VehiclesModuleMessages.analyticReport]: "Informe analítico",
  [VehiclesModuleMessages.batchChangeMaxSpeed]: "Cambiar velocidad máxima de lote",
  [VehiclesModuleMessages.batchChangeMaxSpeedDialogTitle]: "Cambiar velocidad máxima",
  [VehiclesModuleMessages.batchChangeMaxSpeedConfirmation]: "¿Está seguro que desea cambiar la velocidad máxima de los vehículos seleccionados?",
  [VehiclesModuleMessages.batchChangeMaxSpeedCancelSelection]: "Cancelar selección",
  [VehiclesModuleMessages.batchChangeMaxSpeedVehiclesList]: "Vehículos a actualizar:",
  // endregion General
  // region Vehicle Config
  [VehiclesModuleMessages.vehicleCANParameters]: "Parámetros CAN del vehículo",
  [VehiclesModuleMessages.fuelTankSize]: "Capacidad del tanque de combustible (L)",
  [VehiclesModuleMessages.fuelTankSizeEstimated]: "Capacidad estimada automáticamente (L)",
  [VehiclesModuleMessages.fuelTankSizeEstimatedAt]: "estimada el",
  [VehiclesModuleMessages.fuelTankSizeEstimatedTooltip]: "Calculada por la calibración de consumo del vehículo. Si se informa una capacidad arriba, la informada prevalece y esta queda como referencia.",
  [VehiclesModuleMessages.resetFuelTankEstimate]: "Recalcular estimación",
  [VehiclesModuleMessages.resetFuelTankEstimateConfirm]: "Esto borra la estimación actual y el aprendizaje de calibración — el sistema volverá a estimar desde cero en los próximos días de operación. ¿Desea continuar?",
  [VehiclesModuleMessages.resetFuelTankEstimateSuccess]: "Estimación de la capacidad del tanque reiniciada con éxito",
  [VehiclesModuleMessages.resetFuelTankEstimateError]: "Error al reiniciar la estimación de la capacidad del tanque",
  [VehiclesModuleMessages.maxTemperatureLimit]: "Límite máximo de temperatura (°C)",
  [VehiclesModuleMessages.harshAccelerationThreshold]: "Aceleración brusca a partir de (m/s²)",
  [VehiclesModuleMessages.harshBrakingThreshold]: "Frenado brusco a partir de (m/s²)",
  [VehiclesModuleMessages.harshCorneringThreshold]: "Curva pronunciada a partir de (m/s²)",
  [VehiclesModuleMessages.maxRpmLimit]: "Límite máximo de RPM",
  [VehiclesModuleMessages.vehicleCANParametersUpdateSuccess]: "Parámetros CAN del vehículo actualizados con éxito",
  [VehiclesModuleMessages.vehicleCANParametersLoadError]: "Falla al cargar parámetros CAN del vehículo",
  // endregion
  // region Water Factor Control
  [VehiclesModuleMessages.waterFactorControlTitle]: "Control del factor de agua",
  [VehiclesModuleMessages.waterFactorControlTab]: "Control",
  [VehiclesModuleMessages.waterFactorHistoryTab]: "Historial",
  [VehiclesModuleMessages.vehicleWithoutHardwareTooltip]: "El vehículo no tiene un hardware vinculado",
  [VehiclesModuleMessages.controlTabExplanatoryText]: "Para iniciar el procedimiento de calibración, haga clic en el botón de iniciar análisis y "
    + "posterior al inicio añada una cantidad precisamente conocida de agua en el matraz. Seguidamente, interrumpa el análisis en el sistema, "
    + "asignando la cantidad en el campo indicado y presione el botón de calcular y guardar.\n\n"
    + "El sistema utilizará los datos recopilados durante este período para calcular el nuevo factor de corrección (o factor de calibración), "
    + "el cual se mostrará en pantalla como el resultado final del proceso.",
  [VehiclesModuleMessages.controlTabHardwareBrand]: "Marca",
  [VehiclesModuleMessages.controlTabHardwareModel]: "Modelo",
  [VehiclesModuleMessages.controlTabHardwareDevId]: "ID del dispositivo",
  [VehiclesModuleMessages.controlTabAnalysisPeriod]: "Período de análisis",
  [VehiclesModuleMessages.controlTabStartAnalysis]: "Iniciar análisis",
  [VehiclesModuleMessages.controlTabStopAnalysis]: "Interrumpir análisis",
  [VehiclesModuleMessages.controlTabResetAnalysis]: "Reiniciar análisis",
  [VehiclesModuleMessages.controlTabAmountOfWater]: "Cantidad de agua añadida (L)",
  [VehiclesModuleMessages.controlTabCalculateButton]: "Calcular y guardar",
  [VehiclesModuleMessages.controlTabHardwareOffline]: "El hardware del vehículo ha estado desconectado por más de "
    + "30 minutos. No es posible iniciar el análisis.",
  [VehiclesModuleMessages.waterFactorResultTitle]: "¡Cálculo concluido con éxito!",
  [VehiclesModuleMessages.waterFactorResultPreviousFactor]: "Factor anterior:",
  [VehiclesModuleMessages.waterFactorResultHardwareWater]: "Agua (Hardware):",
  [VehiclesModuleMessages.waterFactorResultUserWater]: "Agua (Informada):",
  [VehiclesModuleMessages.waterFactorResultNewCalibration]: "Realizar nueva calibración",
  [VehiclesModuleMessages.waterFactorSourceIntelligentSuggestion]: "Sugerencia inteligente",
  [VehiclesModuleMessages.waterFactorSourceManual]: "Manual",
  [VehiclesModuleMessages.waterFactorSourceRevert]: "Reversión",
  [VehiclesModuleMessages.historyTabCurrentWaterFactor]: "Factor de agua",
  [VehiclesModuleMessages.historyTabPreviousWaterFactor]: "Factor de agua anterior",
  [VehiclesModuleMessages.historyTabSourcedFrom]: "Fuente",
  [VehiclesModuleMessages.historyTabChangedByUser]: "Modificado por",
  [VehiclesModuleMessages.historyTabChangedDate]: "Fecha de modificación",
  [VehiclesModuleMessages.historyTabStatus]: "Status",
  [VehiclesModuleMessages.historyTabActions]: "Acciones",
  [VehiclesModuleMessages.historyTabActiveText]: "Activo",
  [VehiclesModuleMessages.historyTabTooltipActiveText]: "Esta versión ya está activa",
  [VehiclesModuleMessages.historyTabRevertButton]: "Revertir"
  // endregion Water Factor Control

  // endregion
};
